import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import { getUserMenuList } from '@/api/menu'
import Placeholder from '@/views/Placeholder.vue'
import CaseEdit from '@/views/CaseEdit.vue'
import DocumentEdit from '@/views/DocumentEdit.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/case/edit/:caseId?',
    name: 'CaseEdit',
    component: CaseEdit,
    meta: { title: '案件编辑', requiresAuth: true }
  },
  {
    path: '/document/edit/:documentId/:caseId?',
    name: 'DocumentEdit',
    component: DocumentEdit,
    meta: { title: '文书编辑', requiresAuth: true }
  },
  {
    path: '/bookmark-manage/:templateId/:templateName?',
    name: 'BookmarkManage',
    component: () => import('@/views/BookmarkManage.vue'),
    meta: { title: '书签维护', requiresAuth: true }
  },
  {
    path: '/confirm-attendance-sign',
    name: 'ConfirmAttendanceSign',
    component: () => import('@/views/ConfirmAttendanceSign.vue'),
    meta: { title: '确认参会签名', requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
  }
]

const router = new VueRouter({
  routes
})

// 判断路由是否已经加载
let hasLoadedRoutes = false

// 动态加载路由的方法
async function loadDynamicRoutes() {
  console.log('loadDynamicRoutes')
  try {
    const res = await getUserMenuList()
    if (res.code === 200) {
      const menus = res.data || []

      // 注册动态路由
      menus.forEach(menu => {
        // 确保 pageRoute 存在且不为空
        if (!menu.pageRoute || menu.pageRoute.trim() === '') {
          console.warn(`菜单 "${menu.menuName}" 的 pageRoute 为空，已跳过。`)
          return
        }

        const componentPath = menu.pageRoute.replace(/^\//, '') // 移除开头的 '/'
        const routePath = `/${componentPath.replace('.vue', '').toLowerCase()}` // 根据组件路径生成一个简单的路由
        
        // 检查路由是否已存在
        if (!router.getRoutes().find(r => r.path === routePath)) {
          console.log(`正在为菜单 [${menu.menuName}] 添加路由: ${routePath}`)
          
          router.addRoute('Home', {
            path: routePath,
            name: menu.menuName, // 使用菜单名作为路由名
            // 动态导入组件
            component: () => import(`@/views/${componentPath}`), 
            meta: {
              title: menu.menuName,
              requiresAuth: true
            }
          })
        }
      })

      hasLoadedRoutes = true
      return true
    }
    return false
  } catch (error) {
    console.error('加载动态路由失败:', error)
    return false
  }
}

// 路由守卫
router.beforeEach(async (to, from, next) => {
  console.log('router.beforeEach')
  // 设置页面标题
  document.title = to.meta.title || '系统'

  // 获取token
  const token = localStorage.getItem('token')
  
  // 如果是登录页面，直接通过
  if (to.path === '/login') {
    next()
    return
  }

  // 如果路由不需要认证，直接通过
  if (to.meta && to.meta.requiresAuth === false) {
    next()
    return
  }

  // 如果没有token，重定向到登录页
  if (!token) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }
  
  // 如果路由未加载，则加载动态路由
  if (!hasLoadedRoutes) {
    try {
      await loadDynamicRoutes()
      // 路由添加完成后，重新进入当前路由
      next({ ...to, replace: true })
      return
    } catch (error) {
      console.error('加载路由失败:', error)
      next('/login')
      return
    }
  }

  next()
})

export default router